
const toFixed2 = value => {

  if(value == undefined){
    return ''
  }
  return value.toFixed(2)
}
const parseTime2 = function(time,format){

  let first = time.substr(0,time.indexOf('T'))
  let second = time.substr(time.indexOf('T')+1,8)
  if(format){
    return first
  }
  return first+' '+second

}
const parseTime = function(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}
const thousand = num => {
  var reg = /\d{1,3}(?=(\d{3})+$)/g
  return (num + '').replace(reg, '$&,')
}
const parseSource = val => {
  if(val == '0'){
    return '自购'
  }else if(val == 1){
    return '团队'
  }
}


export { toFixed2, parseTime, thousand, parseSource,parseTime2 }
